// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabs[data-v-60f45ddc] {\n  height: 100%;\n}\n.closemodule[data-v-60f45ddc] {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 73px;\n  padding: 20px;\n  border-top: 1px solid #e4e4e4;\n  text-align: right;\n}\n.closemodule .el-button[data-v-60f45ddc] {\n  width: 73px;\n  height: 32px;\n}\n.closemodule .el-button .fontstyle[data-v-60f45ddc] {\n  margin-right: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
